import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { ListResource } from '../../../../components/ListResource/ListResource';

const TransformersData = ({ id, origin }) => {
  const { t } = useTranslation();

  const headers = [
    {
      label: 'sourcePost',
      key: 'sourcePost.name'
    },
    {
      label: 'title',
      key: 'title'
    },
    {
      label: 'nominalPower',
      key: 'nominalPower'
    },
    {
      label: 'voltageHTB',
      key: 'voltageHTB'
    },
    {
      label: 'voltageSet',
      key: 'voltageSet'
    },
    {
      label: 'serviceYear',
      key: 'serviceYear'
    },
    {
      label: 'createdBy',
      key: 'createdBy.first_name'
    },
    {
      label: 'createdBy',
      key: 'createdBy.last_name'
    }
  ];

  const columns = [
    {
      title: t('sourceposts.show.transformerData.sourcePost'),
      key: 'sourcePost',
      dataIndex: 'sourcePost',
      render: ({ name }) => name,
      sorter: true
    },
    {
      title: t('sourceposts.show.transformerData.name'),
      key: 'title',
      dataIndex: 'title',
      sorter: true
    },
    {
      title: t('sourceposts.show.transformerData.nominalPower'),
      key: 'nominalPower',
      dataIndex: 'nominalPower',
      sorter: true
    },
    {
      title: t('sourceposts.show.transformerData.voltageHTB'),
      key: 'voltageHTB',
      dataIndex: 'voltageHTB',
      sorter: true
    },
    {
      title: t('sourceposts.show.transformerData.voltageHTA'),
      key: 'voltageHTA',
      dataIndex: 'voltageHTA',
      sorter: true
    },
    {
      title: t('sourceposts.show.transformerData.voltageSet'),
      key: 'voltageSet',
      dataIndex: 'voltageSet',
      sorter: true
    },
    {
      title: t('sourceposts.show.transformerData.serviceYear'),
      key: 'serviceYear',
      dataIndex: 'serviceYear',
      render: (serviceYear) =>
        (serviceYear && moment(serviceYear).format('YYYY')) || '-',
      sorter: true
    },
    {
      title: t('sourceposts.show.transformerData.createdBy'),
      key: 'createdBy',
      dataIndex: 'createdBy',
      render: (createdBy) =>
        `${createdBy?.first_name || ''} ${createdBy?.last_name}`,
      sorter: true
    }
  ];
  return (
    <ListResource
      withCreateButton={false}
      showAction={false}
      deleteAction={false}
      resourceName="transformers"
      columns={columns}
      headers={headers}
      populate="sourcePost,createdBy,updatedBy"
      extraQuery={`sourcePost=${id}&model=${origin}`}
      resourceModelName="Transformer"
      showTitle={false}
      path={`/${origin}/transformer`}
      withImportButton={false}
    />
  );
};

export default TransformersData;

TransformersData.propTypes = {
  id: PropTypes.string.isRequired,
  origin: PropTypes.string.isRequired
};
